import { createSlice } from '@reduxjs/toolkit'

const paymentSlice = createSlice({
  name: 'paymentInProcess',
  initialState: false,
  reducers: {
    setPaymentIsProcessingLoadingScreen: (state, action) => {
      state = action.payload
      return action.payload
    },
  },
})

export const { setPaymentIsProcessingLoadingScreen } = paymentSlice.actions
export const isInProgress = (state: { paymentInProcess: boolean }) =>
  state.paymentInProcess
export default paymentSlice.reducer
